// extracted by mini-css-extract-plugin
export var dateLabel = "_4k-0";
export var dateLabelError = "_4k-1";
export var fullWidth = "_4k-2";
export var smaller = "_4k-3";